module.exports = __webpack_public_path__ + "static/media/spies-in-disguise-logo@2x.ac25a129.png";